export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4750.0160d8ad.jpg";